import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { getuserReq, rmuserReq, adduserReq, upduserReq, chUsPassReq, notifyReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faEdit, faLock, faPlus, faSpinner, faTrashAlt, faUsers } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import TextInput from '../components/textInput';
import { getFormattedDate } from '../config/helpers';
import DateInput from '../components/dateInput';
import AreaInput from '../components/areaInput';

class Users extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: '',
			phone: '',
			password: '',
			state: '',
			city: '',
			colony: '',
			sector: '',
			pincode: '',
			plot: '',
			dob: '',
			errors: { name: '', phone: '', password: '', state: '', city: '', colony: '', sector: '', pincode: '', plot: '', dob: '' },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			form: false,
			ch: false,
			id: '',
			notif: false,
			title: '',
			message: '',
			image: ''
		};
	}

	componentDidMount() {
		this.getUsers();
	}

	getUsers = () => {
		this.setState({fetchLoading: true});
		getuserReq()
		.then( (res) => {
			this.setState({users: res.data, form: false, ch: false, notif: false});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not fetch users");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}

	rmUser = (id, index) => {
		this.setState({deleteLoading: true});
		rmuserReq({id})
		.then( (res) => {
			const { users } = this.state;
			users.splice(index, 1);
			this.setState({users});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not remove user");
		}).finally( () => {
			this.setState({deleteLoading: false});
		});
	}
	
	handleChange = ({ target: { name, value } }) => {
		if(name === 'phone') {
			this.setState({[name]: ((parseInt(value) || '').toString()).slice(0, 10) || ''});
		} else {
			this.setState({[name]: value});
		}
	}

	validate = () => {
		const { id, name, phone, password, state, city, colony, sector, pincode, plot, dob } = this.state;
		let errors = { name: '', phone: '', password: '', state: '', city: '', colony: '', sector: '', pincode: '', plot: '', dob: '' }, isValid = true;

		if(!name) {
			errors.name = "Enter name to continue";
			isValid = false;
		}
		if(!phone) {
			errors.phone = "Enter phone to continue";
			isValid = false;
		}
		if(!id && !password) {
			errors.password = "Enter password to continue";
			isValid = false;
		}
		if(!state) {
			errors.state = "Enter state to continue";
			isValid = false;
		}
		if(!city) {
			errors.city = "Enter city to continue";
			isValid = false;
		}
		if(!colony) {
			errors.colony = "Enter colony to continue";
			isValid = false;
		}
		if(!sector) {
			errors.sector = "Enter sector to continue";
			isValid = false;
		}
		if(!pincode) {
			errors.pincode = "Enter pin code to continue";
			isValid = false;
		}
		if(!plot) {
			errors.plot = "Enter plot number to continue";
			isValid = false;
		}
		if(!dob) {
			errors.dob = "Select date of birth to continue";
			isValid = false;
		}
		
		this.setState({errors});
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { id, name, phone, password, state, city, colony, sector, pincode, plot, dob } = this.state;
		if(this.validate()) {
			if(id) {
				this.setState({loading: true});
				upduserReq({id, name, phone, state, city, colony, sector, pincode, plot, dob: dob && dob.getTime ? dob.getTime() : ''})
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("User updated");
					this.getUsers();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			} else {
				this.setState({loading: true});
				adduserReq({name, phone, password, state, city, colony, sector, pincode, plot, dob: dob && dob.getTime ? dob.getTime() : ''})
				.then( (res) => {
					this.setState({loading: false});
					alertSuccess("User added");
					this.getUsers();
				}).catch( (err) => {
					this.setState({loading: false});
					alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
				});
			}
		}
	}

	navigateAdd = () => {
		this.setState({ id: '', name: '', password: '', errors: {name: '', phone: '', password: '', state: '', city: '', colony: '', sector: '', pincode: '', plot: '', dob: ''}, loading: false, form: true });
	}

	navigateEdit = (id, name, phone, state, city, colony, sector, pincode, plot, dob) => {
		this.setState({ id, name, phone, state, city, colony, sector, pincode, plot, dob: dob ? new Date(parseInt(dob)) : '', errors: {name: '', phone: '', password: '', state: '', city: '', colony: '', sector: '', pincode: '', plot: '', dob: ''}, loading: false, form: true });
	}

	navigateCh = (id, name) => {
		this.setState({ id, name, password: '', errors: {name: '', phone: '', password: '', state: '', city: '', colony: '', sector: '', pincode: '', plot: '', dob: ''}, ch: true, loading: false});
	}
	
	navigateNotif = (id, name) => {
		this.setState({ id, name, title: '', message: '', image: '', notif: true, loading: false});
	}

	validate2 = () => {
		const { password } = this.state;
		let errors = { name: '', phone: '', password: '', state: '', city: '', colony: '', sector: '', pincode: '', plot: '', dob: '' }, isValid = true;

		if(!password) {
			errors.password = "Enter password to continue";
			isValid = false;
		}
		
		this.setState({errors});
		return isValid;
	}

	submitCh = (e) => {
		e.preventDefault();
		const { id, password } = this.state;
		if(this.validate2()) {
			this.setState({loading: true});
			chUsPassReq({id, password})
			.then( (res) => {
				this.setState({loading: false});
				alertSuccess("Password changed");
				this.getUsers();
			}).catch( (err) => {
				this.setState({loading: false});
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
		}
	}
	
	onChangeDate = (name, e) => {
		this.setState({ [name]: e || '' });
	}
	
	submitNotif = (e) => {
		e.preventDefault();
		const { id:user, title, message, image } = this.state;
		this.setState({loading: true});
		notifyReq({user, title, message, image})
		.then( (res) => {
			this.setState({loading: false});
			alertSuccess("Notification sent to user");
			this.getUsers();
		}).catch( (err) => {
			this.setState({loading: false});
			alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
		});
	}

	render() {
		const { id, name, phone, password, state, city, colony, sector, pincode, plot, dob, ch, users, deleteLoading, errors, loading, fetchLoading, form, notif, title, message, image } = this.state;
		const { handleChange, handleSubmit, navigateAdd, navigateEdit, navigateCh, submitCh, rmUser, onChangeDate, navigateNotif, submitNotif } = this;
		return (
			notif ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>User Notification</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={submitNotif}>
									<Form.Group>
										<TextInput onChange={handleChange} value={title} error={errors.title} name="title" label="Title" />
									</Form.Group>
									<Form.Group>
										<AreaInput onChange={handleChange} value={message} error={errors.message} name="message" label="Message" />
									</Form.Group>
									<Form.Group>
										<TextInput onChange={handleChange} value={image} error={errors.image} name="image" label="Image URL" />
									</Form.Group>

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			: ch ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>Change User Password</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={submitCh}>
									<Form.Group>
										<TextInput onChange={handleChange} value={password} error={errors.password} name="password" label="Password" type="password" />
									</Form.Group>

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			: form ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>{id ? 'Update ' : 'Add '} User</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleSubmit}>
									<Form.Group>
										<TextInput onChange={handleChange} value={name} error={errors.name} name="name" label="Name" />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={phone} error={errors.phone} name="phone" label="Phone Number" />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={state} error={errors.state} name="state" label="State" />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={city} error={errors.city} name="city" label="City" />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={colony} error={errors.colony} name="colony" label="Colony" />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={sector} error={errors.sector} name="sector" label="Sector" />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={pincode} error={errors.pincode} name="pincode" label="Pin Code" />
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={plot} error={errors.plot} name="plot" label="Plot Number" />
									</Form.Group>
									
									<Form.Group>
										<DateInput name="dob" error={errors.dob} selected={dob} onChange={(e) => { onChangeDate('dob', e) }} placeholderText="Date of Birth" />
									</Form.Group>

									{id ?
										<></>
									:
										<Form.Group>
											<TextInput onChange={handleChange} value={password} error={errors.password} name="password" label="Password" type="password" />
										</Form.Group>
									}

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			:
				<Row style={{marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%'}}>
					<Col md={12} style={{justifyContent: 'flex-end', display: 'flex', marginTop: '10px', marginBottom: '15px'}}>
						<Button variant="success" onClick={navigateAdd} size="md">
							<FontAwesomeIcon icon={faPlus} /> Add User
						</Button>
					</Col>
					{fetchLoading && <Loader />}
					{Array.isArray(users) ?
						users.length > 0 ?
							<div className="table-responsive">
								<table className="table table-hover table-attendance">
									<thead>
										<tr>
											<th>ID</th>
											<th>Name</th>
											<th>City, State</th>
											<th>Address</th>
											<th>Pincode</th>
											<th>Date of Birth</th>
											<th className="th1">Action</th>
										</tr>
									</thead>
									<tbody>
										{users.map(({ id, name, phone, state, city, colony, sector, pincode, plot, dob }, i) =>
											<tr key={i}>
												<td>{id}</td>
												<td>{name}</td>
												<td>{city}, {state}</td>
												<td>{sector}/{plot}, {colony}</td>
												<td>{pincode}</td>
												<td>{getFormattedDate(parseInt(dob))}</td>
												<td className="text-center">
													<div className="course-control-box icons-container d-flex">
														<OverlayTrigger overlay={<Tooltip>Edit</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faEdit} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateEdit(id, name, phone, state, city, colony, sector, pincode, plot, dob) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Change Password</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faLock} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateCh(id, name) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Send Notification</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faBell} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateNotif(id, name) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" onClick={(e) => { rmUser(id, i) }} />
														</OverlayTrigger>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						:
							<p style={{position: 'fixed', marginLeft: '34%', marginTop: '20%'}}>No users found.</p>
					:
						<></>
					}
				</Row>
		);
	}
}

export default Users;